module.exports = __webpack_public_path__ + "img/Icon-WithdrawalRequests.af4456a3.svg";